var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("PrintProperties", {
        attrs: {
          internalCode: _vm.internalCode,
          panelID: _vm.panelID,
          title: _vm.title,
          forceFallback: false,
          showZoomToFeatures: false,
          showLayout: false,
          showFormat: false,
          name: "print-visible-properties",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }